"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _components = require("@quarkly/components");
var _widgets = require("@quarkly/widgets");
var _props = require("./props");
var _utils = require("../utils");
var _utils2 = require("./utils");
var _ComponentNotice = _interopRequireDefault(require("../ComponentNotice"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var PopupComponent = function PopupComponent(_ref) {
  var animDuration = _ref.animDuration,
    animFunction = _ref.animFunction,
    onloadShow = _ref.onloadShow,
    props = _objectWithoutProperties(_ref, ["animDuration", "animFunction", "onloadShow"]);
  var _useOverrides = (0, _components.useOverrides)(props, _props.overrides),
    override = _useOverrides.override,
    children = _useOverrides.children,
    rest = _useOverrides.rest;
  var _useState = (0, _react.useState)(onloadShow),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var isEmpty = (0, _react.useMemo)(function () {
    return (0, _utils.isEmptyChildren)(children);
  }, [children]);
  var contentRef = (0, _react.useRef)();
  var mode = (0, _widgets.useConstructorMode)();
  (0, _react.useEffect)(function () {
    setOpen(onloadShow);
    var node = contentRef.current;
    return function () {
      return _utils.toggleScroll.enable(node);
    };
  }, [onloadShow]);
  var popupTransition = (0, _react.useMemo)(function () {
    return isOpen ? "visibility ".concat(animDuration, " step-start, opacity ").concat(animDuration, " ").concat(animFunction) : "visibility ".concat(animDuration, " step-end, opacity ").concat(animDuration, " ").concat(animFunction);
  }, [isOpen, animFunction, animDuration]);
  var wrapperTransition = (0, _react.useMemo)(function () {
    return "transform ".concat(animDuration, " ").concat(animFunction);
  }, [animFunction, animDuration]);
  var openPopup = (0, _react.useCallback)(function () {
    var isDev = (0, _utils.getAPI)().mode === 'development';
    if (isDev && mode === 'constructor') return;
    contentRef.current.scrollTo(0, 0);
    _utils.toggleScroll.disable(contentRef.current);
    setOpen(true);
  }, [mode]);
  var closePopup = (0, _react.useCallback)(function () {
    var isDev = (0, _utils.getAPI)().mode === 'development';
    if (isDev && mode === 'constructor') return;
    _utils.toggleScroll.enable(contentRef.current);
    setOpen(false);
  }, [mode]);
  var context = (0, _react.useMemo)(function () {
    return {
      isOpen: isOpen,
      openPopup: openPopup,
      closePopup: closePopup
    };
  }, [isOpen, openPopup, closePopup]);
  return /*#__PURE__*/_react["default"].createElement(_widgets.Box, rest, /*#__PURE__*/_react["default"].createElement(_widgets.Button, _extends({
    onClick: openPopup
  }, override('Button Open')), override('Button Open').children), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, override('Popup', "Popup ".concat(isOpen ? ':open' : ':closed')), {
    transition: popupTransition
  }), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    onClick: closePopup
  }, override('Overlay', "Overlay ".concat(isOpen ? ':open' : ':closed')))), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, override('Wrapper', "Wrapper ".concat(isOpen ? ':open' : ':closed')), {
    transition: wrapperTransition
  }), /*#__PURE__*/_react["default"].createElement(_widgets.Icon, _extends({}, override('Button Close'), {
    onClick: closePopup
  })), /*#__PURE__*/_react["default"].createElement(_utils2.PopupContext.Provider, {
    value: context
  }, /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, override('Content'), {
    ref: contentRef
  }), children, isEmpty && /*#__PURE__*/_react["default"].createElement(_ComponentNotice["default"], {
    message: "Drag any component here"
  }))))));
};
Object.assign(PopupComponent, {
  title: 'Popup',
  description: {
    en: 'This is a pop-up window that appears when clicking on a button',
    ru: 'Всплывающее окно, которое появляется по клику на кнопку'
  },
  propInfo: _props.propInfo,
  defaultProps: _props.defaultProps,
  overrides: _props.overrides
});
var _default = PopupComponent;
exports["default"] = _default;